import { api } from 'src/api/axios';
import { UserProfile, UserAddress, UpdatePasswordPayload } from './interfaces/profile.interface';

export const getProfile = async () => {
  const { data } = await api.get<UserProfile>('/user/profile');
  return data;
};

export const updateProfile = async (payload: UserProfile) => {
  const { data } = await api.patch<UserProfile>('/user/profile', payload);
  return data;
};

export const getAddress = async () => {
  try {
    const { data } = await api.get<UserAddress>('/user/address');
    return data;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      const empty: UserAddress = {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zipcode: '',
      };
      return empty;
    }
    throw error;
  }
};

export const createServerSetupIntent = async (): Promise<{
  id: string;
  secret: string;
}> => {
  const { data } = await api.post<{ id: string; secret: string }>(
    '/user/payment/setup'
  );
  return data;
};

export const initializePayment = async (applicationId: string | number): Promise<{
  id: string;
  secret: string;
}> => {
  const { data } = await api.post<{ id: string; secret: string }>(
    `/user/applications/${applicationId}/initialize-payment`
  );
  return data;
};

export const updateAddress = async (payload: UserAddress) => {
  const { data } = await api.patch<UserAddress>('/user/address', payload);
  return data;
};

export const updatePassword = async (payload: UpdatePasswordPayload) => {
  const { data } = await api.patch('/user/password', payload);
  return data;
};
